import {
    UI_COLLAPSE_ELEMENT, UI_EXPAND_ELEMENT,
    UI_OPEN, UI_CLOSE, OPEN_POPUP, CLOSE_POPUP, OPEN_IDLE_POPUP, CLOSE_IDLE_POPUP, UI_LAST_ROUTE_TYPE, UI_CURRENT_ROUTE_TYPE, UI_PREVIOUS_PATH, CONFIRMATION_DIALOG_ANSWER,
    UI_LOADING, UI_LOADING_DONE, UI_LOADING_FAILED, UI_LOADING_RESET,
    SAVE_POPUP_TIMER, TOGGLE_POPUP_TIMER, DATA_FINISHED, CHECKED_TICKETS, EARLY_CASHOUT, CHECK_CASHOUT_TICKET, TICKET_SCAN, UI_TOGGLE_ONE_GAME_ALL_MARKETS, TOGGLE_REGION_CLASS, CLOSE_GAME_COMPONENT, MOVE_GAME_STEP, VIRTUALS_VIDEO_STREAM, SPORT_GAMES_COUNT, CHANGE_ODDS_FORMAT
} from './actionTypes/';

/**
 * @name UICollapseElement
 * @description sync action creator function.
 * Each expandable component must have unique key
 * @param {object} key
 * @returns {Object}
 */
export const UICollapseElement = (key) => {
    /**
     * @event collapseComponent
     * */
    return {
        type: UI_COLLAPSE_ELEMENT,
        payload: key
    };
};

/**
 * @name UIExpandElement
 * @description sync action creator function.
 * Each expandable component must have unique key
 * @param {object} key
 * @returns {Object}
 */
export const UIExpandElement = (key) => {
    /**
     * @event expandComponent
    * */
    return {
        type: UI_EXPAND_ELEMENT,
        payload: key
    };
};

/**
 * @name UIOpen
 * @description sync action creator function.
 * Open ui component
 * @param {object} key
 * @returns {Object}
 */
export const UIOpen = (key) => {
    /**
     * @event uiOpen
     * */
    return {
        type: UI_OPEN,
        key
    };
};
/**
 * @name finishLoading
 * @description finish the loader of Tickets
 * @param {bool} payload
 * @returns {bool}
 */
export const finishLoading = (payload) => {
    return {
        type: DATA_FINISHED,
        payload
    };
};
/**
 * @name checkCashoutTicket
 * @description Back End sends the ticket for cashout , if
 * it is available
 * @param {object} payload
 * @returns {object}
 */
export const checkCashoutTicket = (payload) => {
    return {
        type: CHECK_CASHOUT_TICKET,
        payload
    };
};
/**
 * @name ticketScan
 * @description adding scanned ticket tio redux store uiState.Tickets.
 * Open ui component
 * @param {object} payload
 * @param {bool} bool
 * @returns {Object}
 */
export const ticketScan = (payload, bool, barcode) => {
    return {
        type: TICKET_SCAN,
        payload,
        bool,
        barcode
    };
};
/**
 * @name checkedTickets
 * @description getting checked tickets from terminal (Igor).
 * Open ui component
 * @param {array} array
 * @returns {array}
 */
export const checkedTickets = (payload) => {
    return {
        type: CHECKED_TICKETS,
        payload
    };
};
/**
 * @name toggleTimerPopup
 * @description toggle the timer for MultipleTickets in the Header
 * Open ui component
 * @param {payload} bool
 * @returns {bool}
 */
export const toggleTimerInPopup = (payload) => {
    return {
        type: TOGGLE_POPUP_TIMER,
        payload
    };
};
/**
 * @name saveTimer
 * @description Saves The timer after Popup is minimized
 * @param {payload} number
 * @returns {number}
 */
export const saveTimer = (payload) => {
    return {
        type: SAVE_POPUP_TIMER,
        payload
    };
};

/**
 * @name earlyCashoutBets
 * @description Early cashoutedbets from igor
 * @param {payload} object
 * @param {bool} boolean
 * @returns {object}
 */
export const cashoutedBets = (payload, bool) => {
    return {
        type: EARLY_CASHOUT,
        payload,
        bool
    };
};
/**
 * @name UIClose
 * @description sync action creator function.
 * Close opened component
 * @param {object} key
 * @returns {Object}
 */
export const UIClose = (key) => {
    /**
     * @event uiClose
     * */
    return {
        type: UI_CLOSE,
        key
    };
};

/**
 * @name UILoading
 * @description sync action creator function.
 * Loading started
 * @param {object} key
 * @returns {Object}
 */
export const UILoading = (key) => {
    /**
     * @event uiLoadingStart
     * */
    return {
        type: UI_LOADING,
        key
    };
};

/**
 * @name UILoadingDone
 * @description sync action creator function.
 * Loading finished
 * @param {object} key
 * @returns {Object}
 */
export const UILoadingDone = (key) => {
    /**
     * @event uiLoadingDone
     * */
    return {
        type: UI_LOADING_DONE,
        key
    };
};

/**
 * @name UILoadingFailed
 * @description sync action creator function.
 * Loading filed and the file reason
 * @param {object} key
 * @param {object} reason
 * @returns {Object}
 */
export const UILoadingFailed = (key, reason) => {
    /**
     * @event uiLoadingFail
     */
    return {
        type: UI_LOADING_FAILED,
        key,
        reason
    };
};

/**
 * @name OpenPopup
 * @description sync action creator function.
 * To open popup and pass some payload.
 * It's impossible to open multiple popups at the same time.
 * @param {object} key
 * @param {*} payload
 * @returns {Object}
 */
export const OpenPopup = (key, payload) => {
    /**
     * @event openPopup
     */
    return {
        type: OPEN_POPUP,
        key,
        payload
    };
};

/**
 * @name ClosePopup
 * @description sync action creator function.
 * To close opened.
 * It's impossible to open multiple popups at the same time.
 * @returns {Object}
 */
export const ClosePopup = (locationChanged) => {
    /**
     * @event closePopup
     */
    return {
        type: CLOSE_POPUP,
        locationChanged
    };
};


export const OpenIdlePopup = () => ({ type: OPEN_IDLE_POPUP });
export const CloseIdlePopup = () => ({ type: CLOSE_IDLE_POPUP });

/**
 * @name sportGamesCount
 * @description Dispatchs the sportGame Count for checking
 * if there are more than 200 games or not
 * @returns Number
 */
export const sportGamesCount = (payload) => {
    return {
        type: SPORT_GAMES_COUNT,
        payload
    };
};
/**
 * @name ConfirmationDialogAnswer
 * @description sync action creator function.
 * To close Confirmation dialog.
 * It's impossible to open multiple dialogs at the same time.
 * @param {string} key
 * @param {*} answer
 * @param {object} payload
 * @returns {Object}
 */
export const ConfirmationDialogAnswer = (key, answer, payload) => {
    /**
     * @event closeConfirmationDialog
     */
    return {
        type: CONFIRMATION_DIALOG_ANSWER,
        key,
        answer,
        payload
    };
};

/**
 * @name UISetLastRouteType
 * @description sync action creator function.
 * To set last route type for example sport or casino.
 * @returns {Object} routeType
 */
export const UISetLastRouteType = (routeType) => {
    /**
     * @event setLastRouteType
     */
    return {
        type: UI_LAST_ROUTE_TYPE,
        routeType
    };
};

/**
 * @name UISetPreviousPath
 * @description sync action creator function.
 * To set previous route path for example history/bets.
 * @param {string} path
 * @returns {Object}
 */
export const UISetPreviousPath = (path) => {
    /**
     * @event setLastPreviousPath
     */
    return {
        type: UI_PREVIOUS_PATH,
        path
    };
};

/**
 * @name UISetCurrentRouteType
 * @description sync action creator function.
 * To set current route type for example sport or casino
 * @returns {Object} routeType
 */
export const UISetCurrentRouteType = (routeType) => {
    /**
     * @event setCurrentRouteType
     */
    return {
        type: UI_CURRENT_ROUTE_TYPE,
        routeType
    };
};
/**
 * @name toggleGameEventsInList
 * @description toggle all markets of game in game List
 * @returns {Object} routeType
 */
export const toggleGameEventsInList = (bool, gameId) => {
    return {
        type: UI_TOGGLE_ONE_GAME_ALL_MARKETS,
        payload: { bool, gameId }
    };
};
export const virtualsVideoStream = (payload) => {
    return {
        type: VIRTUALS_VIDEO_STREAM,
        payload
    };
};
export const toggleActiveClassRegion = (regionId) => {
    return {
        type: TOGGLE_REGION_CLASS,
        payload: { regionId }
    };
};
export const closeGameComponent = () => {
    return {
        type: CLOSE_GAME_COMPONENT
    };
};
export const moveGameEvevntsInList = (step) => {
    return {
        type: MOVE_GAME_STEP,
        payload: step
    };
};

export const changeOddsFormat = format => ({
    type: CHANGE_ODDS_FORMAT,
    payload: format,
});